import PrivacyScreen from './PrivacyScreen';

export default PrivacyScreen;
